// extracted by mini-css-extract-plugin
export var attachButton = "_kv-8";
export var sendButton = "_kv-2";
export var sendDisabled = "_kv-4";
export var sendEnabled = "_kv-3";
export var sendIcon = "_kv-6";
export var sendIconDisabled = "_kv-7";
export var sendStreaming = "_kv-5";
export var textarea = "_kv-1";
export var wrapper = "_kv-0";